import { fetchConToken } from "../../helpers/fetch";

export const getCity = async()=>{
    try {
        const resp = await fetchConToken( 'api/cities' );
        const body = await resp.json();
        const { status, data } = body;

        if(status === 200){
            return data;
        }else{
            return []
        }
    } catch (error) {
        console.log(error);
    }
}

export const updateCity = async ({ params, id }) => {
    try {
      const rpta = await fetchConToken(`api/cities/${id}`, params, "PUT");
      const body = await rpta.json();
      return body;
    } catch (e) {
      console.log(e);
    }
};

export const getCityById = async(id)=>{
    try {
        const resp = await fetchConToken( `api/cities/${id}` );
        const body = await resp.json();
        return body;
    } catch (error) {
        console.log(error);
    }
}

export const getCityByIdAutoassignedConfig = async(id)=>{
    try {
        const resp = await fetchConToken( `api/cities/autoassigned/${id}` );
        const body = await resp.json();
        return body;
    } catch (error) {
        console.log(error);
    }
}